import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';


const NotAuthorized = () => {
    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <Row>
                <Col className="text-center">
                    <FontAwesomeIcon icon={faBan} size="6x" style={{marginTop:"-100px", marginBottom:"10px", color: "red"}}/>
                    <h1>Not Authorized</h1>
                    <p>You do not have permission to view this page.</p>
                </Col>
            </Row>
        </Container>
    );
};

export default NotAuthorized;